import type { Bookmark, Note } from '../types/api';

const MAX_STACK_NOTES = 3;

/** Build up to three stack frames from notes, keyed by note id (not bookmark id). */
export function buildNotesStackBookmarks(
  notes: Note[],
  bookmarkById: Map<string, Bookmark | undefined>,
): Bookmark[] {
  return notes.slice(0, MAX_STACK_NOTES).map((note) => {
    const bookmark = bookmarkById.get(String(note.bookmark_id));
    return {
      id: String(note.id),
      title: note.bookmark_title || bookmark?.title || '',
      url: note.bookmark_url || bookmark?.url || '',
      description: '',
      progress: 0,
      progressTimestamp: 0,
      liked: false,
      hash: '',
      time: note.time,
      reading_time: bookmark?.reading_time ?? 0,
      og_image: bookmark?.og_image,
    };
  });
}

export function getNotesStackBookmarkIds(notes: Note[]): string[] {
  const ids = new Set<string>();
  for (const note of notes.slice(0, MAX_STACK_NOTES)) {
    ids.add(String(note.bookmark_id));
  }
  return [...ids];
}
